import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import Title from 'antd/lib/typography/Title'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TABLE_MAX_HEIGHT } from '@/constants/customer'
import { Customer } from '@/types'
import { GetCustomerResponse, WashingMethodCustomers } from '@/types/apis/customers/GetCustomerResponse'

import { CustomRowTable } from './styles'

type Props = {
  dataSource: GetCustomerResponse | undefined
  getCustomersLoading: boolean
}

const CustomerDetailTable = ({ dataSource, getCustomersLoading }: Props) => {
  const { t } = useTranslation()

  const columns: ColumnsType<GetCustomerResponse> = [
    {
      title: t('components.pages.customers.list.table.companyId'),
      dataIndex: 'code',
      key: 'code',
      render: (record: Customer) => {
        return <CustomRowTable type="center">{record}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.customers.list.table.shortName'),
      dataIndex: 'shortName',
      key: 'shortName',
      render: (shortName: string) => {
        return <CustomRowTable type="left">{shortName}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.customers.list.table.companyName'),
      dataIndex: 'name',
      key: 'name',
      render: (record: Customer) => {
        return <CustomRowTable type="left">{record}</CustomRowTable>
      },
      align: 'center' as const,
    },
  ]

  const methodColumns: ColumnsType<WashingMethodCustomers> = [
    {
      title: t('components.pages.customers.detail.table.washingMethodName'),
      key: 'name',
      render: (record: WashingMethodCustomers) => {
        return <CustomRowTable type="left">{record.washingMethod.name}</CustomRowTable>
      },
      align: 'center' as const,
    },
    {
      title: t('components.pages.customers.detail.table.time'),
      key: 'time',
      render: (record: WashingMethodCustomers) => {
        return <CustomRowTable type="right">{record.washingMethod.time}</CustomRowTable>
      },
      align: 'center' as const,
    },
  ]

  return (
    <>
      <Table
        rowKey="id"
        bordered
        dataSource={dataSource ? [dataSource] : []}
        columns={columns}
        loading={getCustomersLoading}
        pagination={false}
        scroll={{ x: 'max-content', y: TABLE_MAX_HEIGHT }}
      />
      <Title level={4}>{t('components.pages.customers.detail.tableWashingMethod.title')}</Title>
      <Table
        rowKey="name"
        bordered
        dataSource={dataSource?.washingMethodCustomers}
        columns={methodColumns}
        pagination={false}
        scroll={{ x: 'max-content', y: TABLE_MAX_HEIGHT }}
      />
    </>
  )
}

CustomerDetailTable.displayName = 'CustomerDetailTable'
export default CustomerDetailTable
